export function extractFileName(contentDisposition: string): string {
	let fileName = "document";

	const utfMatch = contentDisposition.match(/filename\*\s*=\s*UTF-8''(.+)/i);
	if (utfMatch && utfMatch[1]) {
		fileName = decodeURIComponent(utfMatch[1]);
	} else {
		const match = contentDisposition.match(/filename="?(.+?)"?(;|$)/i);
		if (match && match[1]) fileName = match[1];
	}

	return fileName;
}
